<template>
    <div class="d-flex flex-column">
        <div class="d-flex flex-column w-75 mx-auto my-3">
            <h1>{{ titulo }}</h1>
            <h6>{{ subTitulo }}</h6>
            <div class="d-flex" style="align-self:flex-end;">
                <b-button variant="primary" @click="$router.push('/');">Voltar</b-button>
            </div>
        </div>
    </div>
</template>


<script>
export default {
	name: "Banner",
	props: [ "titulo", "subTitulo" ],
};
</script>

<style scoped>
h1 {
    font-weight: 500 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/Banner.vue